<template>
    <div>
        <h2
            v-t="'Teamzugehörigkeiten'"
            class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
        ></h2>

        <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        v-t="'team'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Start'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th
                        v-t="'Ende'"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="teamRelation in clubEmployeeTeamRelations"
                    :key="teamRelation.id"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        {{ teamRelation.team.name }}
                        <div class="department-name">
                            ({{ teamRelation.team.departmentName }})
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="isBeingEdited(teamRelation)">
                            <div class="form-widget without-label date-picker">
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(teamRelation)].start"
                                    :invalid="getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])"
                                />
                            </div>
                            <div v-if="getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])">
                                {{ getErrorMessageForExistingStartDate(editRelations[getEditIndex(teamRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ teamRelation.formattedStart() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="isBeingEdited(teamRelation)">
                            <div class="form-widget without-label date-picker">
                                <kgr-date-picker
                                    v-model="editRelations[getEditIndex(teamRelation)].end"
                                    :invalid="getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])"
                                />
                            </div>
                            <div v-if="getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) !== null || isErrorRelation(editRelations[getEditIndex(teamRelation)])">
                                {{ getErrorMessageForExistingEndDate(editRelations[getEditIndex(teamRelation)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ teamRelation.formattedEnd() }}
                        </template>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <kgr-icon-edit
                            v-if="teamRelation.isEditable"
                            :size="15"
                            :disabled="isBeingEdited(teamRelation)"
                            class="kgr-table__action"
                            @click="edit(teamRelation)"
                        />
                        <kgr-icon-delete
                            v-if="teamRelation.isDeletable"
                            class="kgr-table__action"
                            @click="remove(teamRelation)"
                        />
                    </td>
                </tr>

                <tr
                    v-if="isCreatable"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        <kgr-team-select
                            v-model="newRelation.team"
                            :club-id="clubId"
                            hide-label
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.start"
                                :invalid="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationStartDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationStartDate(newRelation) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label date-picker">
                            <kgr-date-picker
                                v-model="newRelation.end"
                                :invalid="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid"
                            />
                        </div>
                        <div v-if="getErrorMessageForNewRelationEndDate(newRelation) !== null || newRelationIsInvalid">
                            {{ getErrorMessageForNewRelationEndDate(newRelation) }}
                        </div>
                    </td><td class="kgr-table__cell"></td>
                </tr>
            </tbody>
        </table>
        <kgr-button
            v-if="showSaveButton"
            class="button_save"
            :value="$t('saveChanges')"
            :disabled="!isSavable"
            :pending="pendingCreate || pendingUpdate"
            @click="save()"
        />
    </div>
</template>

<script>
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository.js';
import ClubEmployeeTeamRelation from '../../js/dto/ClubEmployeeTeamRelation.js';
import DatePicker from '../common/form/picker/DatePicker.vue';
import Error from '../../js/model/Error.js';
import IconDelete from '../common/icon/IconDelete.vue';
import IconEdit from '../common/icon/IconEdit.vue';
import KgrButton from '../common/form/button/KgrButton.vue';
import TeamSelect from '../common/form/select/TeamSelect.vue';
import axios from 'axios';

export default {
    name: 'KgrEmployeeTeamRelationsForm',
    components: {
        'kgr-team-select': TeamSelect,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-button': KgrButton,
        'kgr-date-picker': DatePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
        clubEmployeeTeamRelations: {
            type: Array,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            newRelation: new ClubEmployeeTeamRelation(),
            editRelations: [],
            pendingCreate: false,
            pendingUpdate: false,
            alertMessages: [],
            newRelationIsInvalid: false,
        }
    },
    computed: {
        showSaveButton() {
            return this.isCreatable  ||
                    this.clubEmployeeTeamRelations.filter(r => r.isEditable).length > 0 ||
                    this.clubEmployeeTeamRelations.filter(r => r.isDeletable).length > 0;
        },
        isSavable() {
            if (this.editRelations.length === 0 && this.newRelation.isEmptyTeam()) {
                return false;
            }

            let hasInvalidEdits = this.editRelations.filter(editRelation => !this.isValidDateRange(editRelation)).length > 0;
            if (hasInvalidEdits) {
                return false;
            }

            if (!this.newRelation.isEmptyTeam() && !this.newRelation.isValidTeam()) {
                return false;
            }

            return true;
        },
        regexForDate() {
            return new RegExp('^([0-2][0-9]|(3)[0-1])(\\.)(((0)[0-9])|((1)[0-2]))(\\.)\\d{4}$');
        },
    },
    methods: {
        isErrorRelation(relation) {
            return relation !== undefined && relation.invalid;
        },
        isBeingEdited(teamRelation) {
            return this.getEditIndex(teamRelation) !== -1;
        },
        getEditIndex(teamRelation) {
            return this.editRelations.map(editRelation => editRelation.id).indexOf(teamRelation.id);
        },
        isValidDateRange(teamRelation) {
            if (!teamRelation.end) {
                return true;
            }

            if (!teamRelation.start && teamRelation.end) {
                return false;
            }

            return this.getDateFromString(teamRelation.end) >=  this.getDateFromString(teamRelation.start);
        },
        getDateFromString(dateString) {
            let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;

            return new Date(dateString.replace(pattern,'$3-$2-$1'));
        },
        getErrorMessageForExistingStartDate(relation) {
            let editRelation = this.editRelations[this.getEditIndex(relation)];
            if (editRelation.invalid === true) {
                return this.$t('relation.error.overlapping');
            }
            if (!relation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!this.isValidDate(relation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(relation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForExistingEndDate(relation) {
            if (relation.end && !this.isValidDate(relation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (relation.start && !this.isValidDateRange(relation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationStartDate(newRelation) {
            if (this.newRelationIsInvalid) {
                return this.$t('team.relation.saveChanges.conflict', {'name': this.newRelation.team.name});
            }
            if (!newRelation.isEmptyTeam() && !newRelation.start) {
                return this.$t('Das Startdatum darf nicht leer sein.');
            }
            if (!newRelation.isEmptyTeam() && !this.isValidDate(newRelation.start)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (!this.isValidDateRange(newRelation)) {
                return this.$t('Das Startdatum darf nicht nach dem Enddatum liegen.');
            }
            return null;
        },
        getErrorMessageForNewRelationEndDate(newRelation) {
            if (newRelation.end && !this.isValidDate(newRelation.end)) {
                return this.$t('Das Datum muss im Format DD.MM.YYYY sein.');
            }
            if (newRelation.start && !this.isValidDateRange(newRelation)) {
                return this.$t('Das Enddatum darf nicht vor dem Startdatum liegen.');
            }
            return null;
        },
        isValidDate(date) {
            return this.regexForDate.test(date);
        },
        remove(teamRelation) {
            showConfirm(this.$t('confirm'), this.$t('team.relation.confirm.delete', {'name': teamRelation.team.name}), () => {
                this.editRelations = this.editRelations.filter(r => r.id !== teamRelation.id);
                ClubEmployeeRepository
                    .removeTeam(this.employeeId, teamRelation.id)
                    .then(() => {
                        this.$notify.success('team.relation.delete.success', {'name': teamRelation.team.name});
                        this.emitUpdated();
                    })
                    .catch(() => {
                        this.$notify.error('saveChanges.error');
                    });
            }, 'Ok');
        },
        edit(teamRelation) {
            if (this.isBeingEdited(teamRelation)) {
                return;
            }

            this.editRelations.push(teamRelation.toData());
        },
        save() {
            this.pendingCreate = true;
            this.pendingUpdate = true;
            let apiCalls = [];
            if (!this.newRelation.isEmptyTeam()) {
                this.newRelationIsInvalid = false;
                apiCalls.push(this._createRelation());
            }
            if (this.editRelations.length > 0) {
                apiCalls.push(this._updateRelations(this.editRelations));
            }
            if (apiCalls.length === 0) {
                return;
            }

            axios.all(apiCalls)
                .then(() => {
                    if (this.alertMessages.length > 0 || this.newRelationIsInvalid) {
                        this.alertMessages = this.alertMessages.filter((value, index) => this.alertMessages.indexOf(value) === index);
                        this.$notify.error(this.alertMessages);
                    } else {
                        this.$notify.success('saveChanges.success');
                    }
                })
                .finally(() => {
                    this.editRelations = this.editRelations.filter(relation => relation.invalid === true);
                    this.emitUpdated();
                    this.pendingCreate = false;
                    this.pendingUpdate = false;
                    this.alertMessages = [];
                });
        },
        async _createRelation() {
            this.newRelationIsInvalid = false;
            return ClubEmployeeRepository
                .createTeamRelation(this.newRelation.team.id, this.newRelation, this.employeeId)
                .then(() => {
                    this.newRelation = new ClubEmployeeTeamRelation();
                    this.newRelationIsInvalid = false;
                })
                .catch(error => {
                    this.newRelationIsInvalid = true;
                    if (error.status === 409) {
                        this.alertMessages.push(this.$t('{name} ist dieser Abteilung im gewählten Zeitraum bereits zugewiesen.', {'name': this.newRelation.team.name}));
                    } else {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                    }
                })
        },
        _updateRelations(editRelations) {
            return axios.all(editRelations.map(async teamRelation => {
                teamRelation.invalid = false;
                return ClubEmployeeRepository.updateTeamRelation(teamRelation)
                    .catch(() => {
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                        teamRelation.invalid = true;
                    });
            }));
        },
        emitUpdated() {
            this.$emit('updated');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .button_save {
        display: block;
        margin-left: auto;
    }
    div .date-picker {
        border: 1px solid transparent;

        &.invalid {
            border: 1px solid #F44336;
        }
    }
    .department-name {
        font-size: 80%;
    }
</style>
